import { connect } from 'react-redux';
import { firebase, helpers } from 'redux-react-firebase';
import { withRouter } from 'react-router-dom';
import Forgot from '../../components/auth/forgot';

const { pathToJS } = helpers;

const mapStateToProps = state => ({
  authError: pathToJS(state.firebase, 'authError'),
});

export default withRouter(firebase()(connect(mapStateToProps)(Forgot)));



// WEBPACK FOOTER //
// ./src/containers/auth/forgot.js